import 'jquery';
import { $window } from '../Constants';
import HtmlElement from './HtmlElement';

/**
 * Videos
 */
const Videos = (($) => {
  // Constants
  const DATA_KEY = 'ig.videos';
  const EVENT_KEY = `.${DATA_KEY}`;

  /**
   * Selector
   */
  const Selector = {
    VIDEOS: '.videos',
    VIDEO: '.videos-video',
    VIDEOS_NAV_ITEM: '.videos-nav li',
    VIDEO_IFRAME: '.videos-video-iframe',
    VIDEOS_CONTENT: '.videos-content'
  };

  /**
   * ClassName
   */
  const ClassName = {
    ACTIVE: 'act'
  };

  /**
   * Event
   */
  const Event = {
    RESIZE: `resize${EVENT_KEY}`,
    VIDEO_CLICK: `click${EVENT_KEY}`,
  };

  /**
   * Videos
   *
   * @class
   * @augments HtmlElement
   */
  class Videos extends HtmlElement {
    // Public

    /**
     * Handles ready event
     *
     * @return void
     */
    onReady() {
      this._$videos = this.$element.find('.videos-video');
      this._players = [];
      this._videoWidth = '100%';
      this._videoHeight = '400';
      this._active = 1;

      YT.ready(() => {
        this._players = this._initPlayers();
        this._changeVideo(this._active);
      });

      this._bindHandlers();
    }

    // Private

    /**
     * Initializes the players
     *
     * @return { Array } players
     */
    _initPlayers() {
      let players = [],
          player = null;

      this._$videos.each((i, el) => {
        let $video = $(el);

        player = new YT.Player($video.find(Selector.VIDEO_IFRAME).attr('id'), {
          width: this._videoWidth,
          height: this._videoHeight,
          videoId: $video.data('id')
        });

        players.push(player);
      });

      return players;
    }

    /**
     * Binds the event handlers to the elements
     *
     * @return void
     */
    _bindHandlers() {
      $window.on(Event.RESIZE, () => {
        this._setVideosContentHeight(this._getActiveVideo().height());
      });

      this.$element.find(Selector.VIDEOS_NAV_ITEM).stop(true, false).on(Event.VIDEO_CLICK, (e) => {
        this._pauseVideos();
        this._changeVideo($(e.currentTarget).data('video'));
      });
    }

    /**
     * Changes the video
     *
     * @param { int } id
     * @return void
     */
    _changeVideo(id) {
      this._setNavActive(id);

      let $activeVideo = this._getActiveVideo();

      $activeVideo.fadeOut(300, () => {
        this.$element.find(`#videos-video-${id}`).fadeIn(400);
        this._active = id;

        this._setVideosContentHeight($activeVideo.height());
      });
    }

    /**
     * Returns the active video
     *
     * @return { jQuery }
     */
    _getActiveVideo() {
      return this.$element.find('#videos-video-' + this._active);
    }

    /**
     * Sets the nav item with given id to active
     *
     * @param { int } id
     * @return void
     */
    _setNavActive(id) {
      this.$element.find(Selector.VIDEOS_NAV_ITEM).removeClass(ClassName.ACTIVE);
      this.$element.find(`${Selector.VIDEOS_NAV_ITEM}[data-video="${id}"]`).addClass(ClassName.ACTIVE);
    }

    /**
     * Sets the content height of the videos
     *
     * @param { int } height
     * @return void
     */
    _setVideosContentHeight(height) {
      this.$element.find(Selector.VIDEOS_CONTENT).css('height', height);
    }

    /**
     * Pauses all videos that are playing
     *
     * @return void
     */
    _pauseVideos() {
      this._players.forEach((player) => {
        if (player.getPlayerState() === YT.PlayerState.PLAYING) {
          player.pauseVideo();
        }
      });
    }
  }

  return Videos._getElements(Selector.VIDEOS, Videos)
})(jQuery);

export default Videos;
